import React from "react";
import "./whatWeOffer.css";

const WhatWeOffer = () => {
  return (
    <section className="offer-section">
      <div className="offer-container">
        <header className="offer-header">
          <h2 className="offer-title">Built for Growth at Every Level</h2>
          <p className="offer-subtitle">
            Whether you are beginning your career or leading at scale, Reszko
            Nation provides the structure and opportunity to operate at the
            highest standard.
          </p>
        </header>

        <div className="offer-grid">
          <article className="offer-card">
            <div className="offer-icon" aria-hidden="true">
              {/* Growth icon */}
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 19V5M4 19H20"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M7 16V12M11 16V9M15 16V6M19 16V10"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M7 8l3 2 4-4 4 3"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h3 className="offer-cardTitle">For Emerging Professionals</h3>
            <div className="offer-divider" aria-hidden="true" />
            <p className="offer-cardBody">
              Structured onboarding, mentorship, and real-world training
              designed to accelerate your development from day one.
            </p>
          </article>

          <article className="offer-card">
            <div className="offer-icon" aria-hidden="true">
              {/* Shield/handshake icon */}
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2l7 4v6c0 5-3 9-7 10-4-1-7-5-7-10V6l7-4Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.2 12.2l2.3 2.3 5.3-5.3"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h3 className="offer-cardTitle">For Established Producers</h3>
            <div className="offer-divider" aria-hidden="true" />
            <p className="offer-cardBody">
              Access to 30+ carrier partnerships, national infrastructure, and a
              platform built to support scalable production.
            </p>
          </article>

          <article className="offer-card">
            <div className="offer-icon" aria-hidden="true">
              {/* Crown icon */}
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 8l4 4 4-6 4 6 4-4v10H4V8Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 18h16"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <h3 className="offer-cardTitle">For Leaders in the Making</h3>
            <div className="offer-divider" aria-hidden="true" />
            <p className="offer-cardBody">
              Clear advancement pathways, team-building opportunities, and
              performance-driven leadership development.
            </p>
          </article>

          <article className="offer-card">
            <div className="offer-icon" aria-hidden="true">
              {/* Globe/leaf icon */}
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <path
                  d="M2 12h20"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M12 2c3 3 4.5 6.5 4.5 10S15 19 12 22c-3-3-4.5-6.5-4.5-10S9 5 12 2Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h3 className="offer-cardTitle">For Visionary Builders</h3>
            <div className="offer-divider" aria-hidden="true" />
            <p className="offer-cardBody">
              A nationally expanding organization positioned for long-term
              growth, influence, and market impact.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
